'use client'
import { faBars, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import Image from 'next/image';
import { useState } from 'react';
import { Dialog, DialogPanel } from '@headlessui/react'

type Props = {
  sectionName: string;
}

export default function Header(props: Props) {
  const { sectionName } = props;
  const [open, setOpen] = useState(false)

  const getNav = (sectionName: string): {
    background?: string;
    line1?: string;
    line2?: string;
    lineHeight?: string;
    buttonColor?: string;
    titleUnderline: string;
    url: string;
  } => {
    switch(sectionName) {
      case 'programas':
        return {
          line1: '/images/lines/longCircles.png',
          line2: '/images/lines/longCircles.png',
          lineHeight: 'h-6',
          buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
          titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
          url: 'https://wa.me/50662236864'
        };
      case 'acerca':
        return {
          background: 'bg-white rounded-br-[53px] py-4 w-max px-44 pr-4',
          line1: '/images/lines/longCircles.png',
          line2: '/images/lines/longCircles.png',
          lineHeight: 'h-6',
          buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
          titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
          url: 'https://wa.me/50662236864'
        }
      case 'eventos':
        return {
          line1: '/images/lines/longCirclesPink.svg',
          lineHeight: 'h-10 md:h-16',
          buttonColor: 'bg-gradient-to-r from-[#CE2341] to-[#EE3E5D]',
          titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-red after:w-full after:-bottom-2 after:right-0',
          url: '#contacto'
        }
      case 'instalaciones':
        return {
          line1: '/images/lines/longCircles.png',
          line2: '/images/lines/longCircles.png',
          lineHeight: 'h-6',
          buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
          titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
          url: 'https://wa.me/50662236864'
        }
      case 'basico':
        return {
          line1: '/images/lines/longCircles.png',
          line2: '/images/lines/longCircles.png',
          lineHeight: 'h-6',
          buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
          titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
          url: 'https://wa.me/50662236864'
        };
      default:
        return {
          line1: '/images/lines/longCircles.png',
          line2: '/images/lines/longCircles.png',
          lineHeight: 'h-6',
          buttonColor: 'bg-gradient-to-r from-[#FBA919] to-[#F68729]',
          titleUnderline: 'after:h-0.5 after:rounded-full after:block after:bg-orange-light after:w-full after:-bottom-2 after:right-0',
          url: 'https://wa.me/50662236864'
        }
    }
  }

  const isCurrentSection = (linkSection: string) => sectionName === linkSection;

  const nav = getNav(sectionName);

  return (
    <header className='absolute top-0 w-full overflow-x-hidden z-10'>
      <div className="relative">
        {nav.line1 && (
          <Image 
            src={nav.line1} 
            width={439} 
            height={24} 
            className={`${nav.lineHeight} absolute top-0 left-0 w-auto`} 
            alt="Decoration"
            {...(nav.line1.endsWith('.svg') ? { unoptimized: true } : {})}
          />
        )}
        <nav className={`${nav.background}`}>
          <div className='flex items-center justify-between pt-10 gap-10 bigscreen-responsive'>
            <Link href="/"><Image src="/images/logos/amuraLogo.svg" width={160} height={40} className="h-10 w-40 md:h-25" alt="amura centro culinario" unoptimized/></Link>
            <ul className="hidden xl:flex items-center px-4 py-4 gap-16 text-dark font-bold text-sm rounded-full border border-white glassy text-center">
              <li className={`${isCurrentSection('programas') ? nav.titleUnderline : ''} hover:text-gray-600 relative after:absolute`}>
                <Link href='/programas'>Programas <br /> Técnicos</Link>
              </li>
              <li className={`${isCurrentSection('vida-estudiantil') ? nav.titleUnderline : ''} hover:text-gray-600 relative after:absolute`}>
                <Link href='/vida-estudiantil'>Vida <br /> Estudiantil</Link>
              </li>
              <li className={`${isCurrentSection('eventos') ? nav.titleUnderline : ''} hover:text-gray-600 relative after:absolute`}>
                <Link href='/eventos'>Eventos & <br /> Experiencias</Link>
              </li>
              <li className={`${isCurrentSection('instalaciones') ? nav.titleUnderline : ''} font-thin hover:text-gray-500 relative after:absolute`}>
                <Link href='/instalaciones'>Instalaciones</Link>
              </li>
              <li className={`${isCurrentSection('acerca') ? nav.titleUnderline : ''} font-thin hover:text-gray-500 relative after:absolute`}>
                <Link href='/acerca'>Acerca</Link>
              </li>
              <li className={`${isCurrentSection('blog') ? nav.titleUnderline : ''} hidden font-thin hover:text-gray-500 relative after:absolute`}>
                <Link href='/blog'>Blog</Link>
              </li>
              <li><Link href={nav.url} className={`${nav.buttonColor} text-white rounded-full py-4 px-8 shadow-sm hover:shadow-lg`}>¡Hablemos!</Link></li>
            </ul>
            <div className='xl:hidden'>
              <button onClick={()=>setOpen(true)} aria-label="Abrir menú">
                <FontAwesomeIcon icon={faBars} className='text-2xl mr-2' />
              </button>
            </div>
          </div>
        </nav>
      </div>

      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <div className="fixed inset-0" />
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden bg-black/70">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen max-w-sm transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
              >
                <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                  <div className="px-4 sm:px-6">
                    <div className="flex items-start justify-between">
                      <Link href="/"><Image src="/images/logos/amuraLogo.svg" width={160} height={40} className="h-10 w-40 md:h-25" alt="amura centro culinario" unoptimized/></Link>
                      <div className="ml-3 flex h-7 items-center">
                        <button
                          type="button"
                          onClick={() => setOpen(false)}
                          className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                          aria-label="Cerrar menú"
                        >
                          <span className="absolute -inset-2.5" />
                          <span className="sr-only">Close panel</span>
                          <FontAwesomeIcon icon={faXmark} className="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="relative mt-6 flex-1 px-4 sm:px-6 flex flex-col justify-between">
                    <ul className="px-10 w-full text-lg">
                      <li className="font-bold hover:text-gray-600 relative after:absolute my-10">
                        <Link href='/'>Inicio</Link>
                      </li>
                      <li className="font-bold hover:text-gray-600 relative after:absolute my-10">
                        <Link href='/programas'>Programas <br /> Técnicos</Link>
                      </li>
                      <li className="font-bold hover:text-gray-600 relative after:absolute my-10">
                        <Link href='/vida-estudiantil'>Vida <br /> Estudiantil</Link>
                      </li>
                      <li className="font-bold hover:text-gray-600 relative after:absolute my-10">
                        <Link href='/eventos'>Eventos & <br /> Experiencias</Link>
                      </li>
                      <li className="font-thin hover:text-gray-500 relative after:absolute my-10">
                        <Link href='/instalaciones'>Instalaciones</Link>
                      </li>
                      <li className="font-thin hover:text-gray-500 relative after:absolute my-10">
                        <Link href='/acerca'>Acerca</Link>
                      </li>
                      {/* <li className="font-thin hover:text-gray-500 relative after:absolute my-10">
                        <Link href='/blog'>Blog</Link>
                      </li> */}
                    </ul>
                    <div className='text-center my-10'>
                      <Link href='https://wa.me/50662236864' target='_blank' className={`${nav.buttonColor} text-white rounded-full py-4 px-8 shadow-sm hover:shadow-lg inline`}>¡Hablemos!</Link>
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </header>
  );
}